import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

// The CMS doesn't return buttons, it instead returns <p><a><img src='Book-now-button.png'>
// We map over the data and convert them to actual buttons

// TODO stretch goal, get all a tags and change them to Links where appropriate 
export const transformContent = (content) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(content, 'text/html');

  return Array.from(doc.body.childNodes).map((node, index) => {
    // Handle "Book Now" button inside <p> elements
    if (node.nodeName === 'P') {
      const anchor = node.querySelector('a');
      const img = anchor?.querySelector('img');

      if (img && img.src.includes('Book-now-button.png')) {
        const url = new URL(anchor.href, window.location.origin);
        const isInternal = url.hostname.includes('breakfreeholidays.co.uk');

        return (
          <div key={index} className="d-flex justify-content-center mb-5">
            {isInternal ? (
              <Link to={url.pathname}>
                <Button className="btn btn-primary" style={{ width: '300px' }}>
                  Book Now
                </Button>
              </Link>
            ) : (
              <a href={anchor.href} target="_blank" rel="noopener noreferrer">
                <Button className="btn btn-primary" style={{ width: '300px' }}>
                  Book Now
                </Button>
              </a>
            )}
          </div>
        );
      }
    }

    // Handle text nodes properly
    if (node.nodeType === Node.TEXT_NODE) {
      return node.textContent.trim() ? node.textContent : null;
    }

    // Convert other elements into React elements
    return React.createElement(
      node.nodeName.toLowerCase(),
      { key: index, dangerouslySetInnerHTML: { __html: node.innerHTML } }
    );
  })
};